import { ContentVisibility } from '@fs/zion-rootstech'
import StageDetail from './StageDetail'

const CalendarDetail = `
  ${StageDetail}
  ${ContentVisibility}
  fragment CalendarDetail on CalendarDetail {
    title
    stages {
      ...StageDetail
    }
    visibility {
      ...ContentVisibility
    }
  }
`
export default CalendarDetail
